export default __webpack_public_path__ + "static/media/orca.73cd71c0.jpg";